import React, { ChangeEvent, FC } from 'react';
import FormInfoTooltip from '../FormInfoTooltip';
import { FormGroup } from '../formInterfaces';
import { InputStyled, FormLabelStyled, RequiredAsteriskStyled } from '../styled';

const TextareaForm: FC<Partial<FormGroup>> = ({ label, placeholder, value, onChange, isOptional, information }) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.(e);
    };

    return (
        <>
            <FormLabelStyled>
                {label}{isOptional === false && <RequiredAsteriskStyled>*</RequiredAsteriskStyled>}{information && <FormInfoTooltip information={information} />}
            </FormLabelStyled>
            <InputStyled
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
                placeholder={placeholder}
                value={value}
            />
        </>
    );
};

export default TextareaForm;
